export const appGroupIdOperatorMcpConnectionsTools = "/:app_group_id/operator_mcp_connections/tools";
